<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-13 09:23:25
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-03-01 18:15:48
-->
<template>
  <div>
    <mrc_ess_table
      v-if="$route.name == 'emailtemplate'"
      :headers="headers"
      pageName="addemailtemplate"
      :hideAddBtn="!hasBtn('add-email-template')"
      :paginationOptions="options"
      @turnPage="getlist"
      :isLoading="loading"
      :slotKey="['template_name', 'is_used', 'template_code']"
      :items="desserts"
    >
      <template v-slot:search>
        <v-row
          class="d-flex justify-end"
          style="background: white;
          margin: 0;
          border-top-right-radius: 8px;
          border-top-left-radius: 8px;padding: 0 16px"
        >
          <mrc_ess_advanceFilterAndSearchInput
            class="mt-4"
            v-model="systemSeniorQueryString"
            @success="getlist({ cpage: 1 })"
            :systemFieldMeta="systemFieldMeta"
          ></mrc_ess_advanceFilterAndSearchInput>
        </v-row>
      </template>
      <template #item.template_code="{item}">
        <!-- <span>{{ INT(item.template_code) }}</span> -->
        <mrc_ess_dictName
          v-model="item.template_code"
          view
          dict_name="MailTempldateCode"
        >
        </mrc_ess_dictName>
      </template>
      <template #item.template_name="{item}">
        <span>{{ INT(item.template_name) }}</span>
      </template>
      <!-- 状态 -->
      <template v-slot:item.is_used="{ item }">
        <mrc_ess_viewbtn
          :is_used="item.is_used_save_value"
          :label="item.is_used"
        ></mrc_ess_viewbtn>
      </template>

      <!-- 操作 -->
      <template v-slot:item.actions="{ item }">
        <menu-list :list="menulist" @handleClick="handleClick($event, item)">
          <template v-slot:showAction>
            <v-icon
              v-btnAuth="[
                'view-email-template',
                'edit-email-template',
                'delete-email-template',
              ]"
              >mdi-dots-vertical</v-icon
            >
          </template>
        </menu-list>
      </template>
    </mrc_ess_table>
    <router-view v-else></router-view>
    <!-- <mrc_ess_myDialog v-model="dialog"
                      :title="$t('label_Preview_the_mail_delivery_page')"
                      width='847'
                      :disabled='false'>
      <img :src="img"
           style="width:764px"
           alt="">
    </mrc_ess_myDialog> -->
  </div>
</template>

<script>
import {
  getemailtemplatelist,
  getdetailemailtemplate,
  deleteemailtemplate,
} from "@/service/api/emailtemplate"
export default {
  components: {},
  props: {},
  data() {
    return {
      systemFieldMeta: [],
      field_alias_name: null,
      table_alias_name: null,
      systemSeniorQueryString: [],
      img: require("@/assets/img/emailTemplate.png"),
      disabled: true,
      list: {},
      dialog: false,
      options: {
        pagesize: this.$store.state.pageSize, //条数
        cpage: this.$store.state.cpage, //页数
        totalcount: null, //总条数
        totalpage: null, //总页数
        selectlist: [10, 20, 50, 100, 200],
        pagetext: this.$t("label_Each_page_shows"),
      },
      loading: false,
      desserts: [],
    }
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t("label_Template_name"),
          align: "start",
          value: "template_name",
          sortable: false,
        },
        {
          text: this.$t("label_classification"),
          align: "start",
          value: "template_code",
          sortable: false,
        },

        {
          text: this.$t("label_state"),
          value: "is_used",
          sortable: false,
          align: "center",
        },
        { text: "", value: "actions", sortable: false, align: "end" },
      ]
    },
    menulist() {
      return [
        {
          name: this.$t("label_View"),
          show: this.hasBtn("view-email-template"),
          type: "view",
        },
        {
          name: this.$t("label_Edit"),
          show: this.hasBtn("edit-email-template"),
          type: "edit",
        },
        {
          name: this.$t("label_delete"),
          show: this.hasBtn("delete-email-template"),
          type: "del",
        },
      ]
    },
  },
  beforeCreate() {
    this.$store.commit("setCpage", 1)
  },
  async created() {
    await this.getBtnPermissionList()
  },
  watch: {
    $route(v) {
      if (v.name == "emailtemplate") {
        this.getlist()
      }
    },
  },
  async mounted() {
    await this.getlist()
  },
  beforeDestroy() {},
  methods: {
    async getlist(obj) {
      this.loading = true
      if (
        this.desserts &&
        this.desserts.length == 1 &&
        this.options.cpage != 1 &&
        this.$route.params.type == "del"
      )
        this.options.cpage--
      if (obj) {
        const { cpage, pagesize } = obj

        this.options = { ...this.options, ...obj }
      }
      const res = await getemailtemplatelist({
        cpage: this.options.cpage,
        pagesize: this.options.pagesize,
        systemSeniorQueryString: this.systemSeniorQueryString,
        field_alias_name: this.field_alias_name,
        table_alias_name: this.table_alias_name,
      })
      if (res.code == 200) {
        this.desserts = res.data
        this.options.totalcount = res.totalcount
        this.options.totalpage = res.totalpage
        this.systemFieldMeta = res.systemFieldMeta
        this.field_alias_name = res.field_alias_name
        this.table_alias_name = res.table_alias_name
      }
      this.loading = false
    },
    turnPage({ cpage, pagesize }) {
      this.options.cpage = cpage
      this.options.pagesize = pagesize
      this.getlist()
    },
    previewemail() {
      //预览邮件模板
      this.dialog = true
    },
    addemailtemplate() {
      this.$store.commit("set_subPage_name", "")
      this.$store.commit("set_uuid", "")
      this.$store.commit("set_iconstatus", "") //行内进图标显示
      this.$router.push({
        name: "addemailtemplate",
      })
    },
    godetail(item) {
      this.$store.commit("set_iconstatus", true) //行内进图标显示
      this.$store.commit("set_subPage_name", item.template_name)
      this.$store.commit("set_uuid", item.uuid) //
      this.$router.push({
        name: "detailemailtemplate",
      })
    },
    handleClick({ index, item }, obj) {
      switch (item.type) {
        case "view":
          this.godetail(obj)
          break
        case "edit":
          this.$store.commit("set_subPage_name", obj.template_name)
          this.$store.commit("set_iconstatus", false) //行内进图标显示
          this.$store.commit("set_uuid", obj.uuid) //
          this.$router.push({
            name: "detailemailtemplate",
          })
          break
        case "del":
          this.$myConfirm({
            content: this.$t("message_Confirm_the_deletion"),
          }).then((res) => {
            deleteemailtemplate({ uuid: obj.uuid }).then((res) => {
              if (res.code == 200) {
                this.$Message({
                  text: this.$t("message_The_deletion_was_successful"),
                })
                if (this.desserts.length == 1) this.options.cpage--
                this.getlist()
              }
            })
          })
          break
      }
    },
  },
}
</script>

<style scoped>
.cardtitle {
  position: relative;
}
.emailbtn {
  position: absolute;
  right: 70px;
  top: -50px;
}
</style>
